import {
  DataTableSource,
  type DataTablePageOptions,
  type DataTablePageReq,
  type DataTablePageResp,
} from "@carbon6/c6-frontend-design";
import { getPartApi, type PartKind, type PartRecord } from "./partsCatalog";
import {
  createPartsTableRow,
  createPartsTableRows,
  type PartsTableRow,
  type PartsTableRowClickHandler,
} from "./PartsTableRow";

type PartsTableSourceOptions = {
  kind: PartKind;
  pageSize: number;
  rowClickHandler: PartsTableRowClickHandler;
  resolveErrorMessage: (error: unknown) => string;
};

// 부품 카탈로그(EndEffector/Tip) 공용 table source. 종류는 생성자에서 고정한다.
export class PartsTableSource extends DataTableSource<PartsTableRow> {
  private readonly kind: PartKind;
  private readonly rowClickHandler: PartsTableRowClickHandler;

  constructor({ kind, pageSize, rowClickHandler, resolveErrorMessage }: PartsTableSourceOptions) {
    super({ initialPageSize: pageSize, resolveErrorMessage });
    this.kind = kind;
    this.rowClickHandler = rowClickHandler;
  }

  createRow(record: PartRecord): PartsTableRow {
    return createPartsTableRow(record, this.rowClickHandler);
  }

  protected override async onPage(
    req: DataTablePageReq,
    { signal }: DataTablePageOptions,
  ): Promise<DataTablePageResp<PartsTableRow>> {
    const response = await getPartApi(this.kind).list(
      { page: req.page, size: req.size },
      { signal },
    );
    return {
      rows: createPartsTableRows(response.items, this.rowClickHandler),
      total: response.total,
      page: response.page,
      size: response.size,
    };
  }
}
